import React from "react";
import { Link } from "react-router-dom";

import ContactForm from "./ContactForm";

import "../styles/components/SectionContact.css";

const SectionContact = ({ data, version, pageType }) => {
  return (
    <div className="split split__contact">
      <div className="section-contact container container-small">
        <div className="section-contact--desc">
          {version === 1 ? (
            <div>
              <h6>Masz pytania?</h6>
              <h5>Chętnie odpowiemy</h5>
            </div>
          ) : (
            <h5 dangerouslySetInnerHTML={{ __html: data.title }} />
          )}
        </div>
        <div className="row">
          <div className="col-12 col-md-3 left-side">
            {version === 1 ? (
              <Link
                className="btn-general btn-general--secondary"
                to="/kontakt"
              >
                Kontakt
              </Link>
            ) : (
              <address>
                <h4>
                  <a href={`tel:+48${data.phoneNumber.replace(/\s/g, "")}`}>
                    + 48 <span className="color-black">{data.phoneNumber}</span>
                  </a>
                </h4>

                <h3>
                  <a href={`mailto:${data.emailAddress}`}>
                    {data.emailAddress}
                  </a>
                </h3>
                <div dangerouslySetInnerHTML={{ __html: data.contactData }} />
              </address>
            )}
          </div>
          <div
            className={`col-12 col-md-9 right-side ${
              version === 1 ? "version-1" : ""
            }`}
          >
            <div className="row">
              <div className="col-12 offset-0 col-lg-10 offset-lg-1">
                <ContactForm
                  wrapperClasses={`contact-form`}
                  pageType={pageType}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionContact;
